import axios, { AxiosRequestConfig } from 'axios';
import { getOpenModalFn } from './modal';
import { API_BASE_URL } from '~/env';
import restaurantStore from '~/App/store/restaurant';
import authStore from '~/App/store/auth';
import { init } from '@restaurant/api';

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = authStore.getToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: token,
      };
    }

    const restaurantId = restaurantStore.getRestaurantId();
    if (restaurantId) {
      config.params = {
        ...config.params,
        restaurantId,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    if (
      response.config.responseType === 'blob' ||
      response.config.responseType === 'arraybuffer'
    ) {
      return response;
    }
    return response.data;
  },
  function (error) {
    const { response } = error;
    if (response.status === 401) {
      const openModal = getOpenModalFn();
      if (openModal != null) {
        openModal();
      }
      return;
    }
    const msg =
      error?.response?.data?.message ?? error?.response?.data?.errorMsg;
    if (msg) {
      return Promise.reject(new Error(msg));
    }
    return Promise.reject(error);
  }
);

const httpClient = {
  get: <T>(url: string, config?: AxiosRequestConfig<any> | undefined) =>
    instance.get<any, T>(url, config),
  post: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.post<any, T>(url, data, config),
  put: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.put<any, T>(url, data, config),
  patch: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.patch<any, T>(url, data, config),
  delete: <T>(url: string, config?: AxiosRequestConfig<any> | undefined) =>
    instance.delete<any, T>(url, config),
};

init(httpClient);

export default httpClient;
